var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    className: "like_svg__design-iconfont"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.148 17.63c2.001-7.26-1.561-7.63-2.74-7.63-1.18 0-1.244 1-1.244 1.298 0 3.55-3.84 6.866-3.84 6.866V29.06l8.938-.01c2.485.01 2.749-1.88 2.749-1.88 1.92-6.412 1.92-8.32 1.92-8.32 0-1.325-1.298-1.219-1.298-1.219h-4.485ZM15.324 18.164h-2.435c-.875 0-1.585.71-1.585 1.586v7.714c0 .876.71 1.586 1.585 1.586h2.435V18.164Z"
  }))));
};
export default SvgLike;